function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useMemo } from 'react';
import { useLogger } from '../use-logger';
import { usePromise } from '../use-promise';
import { AdvisorContext } from './advisor-context';
/**
 * Url in which the advisors live.
 */

var ADVISOR_HOST = 'https://advisors-static.ownup.com';
/**
 * Context provider for Advisor Data. When added to the DOM, all
 *   of its children will be able to use the {@link useAdvisor}
 *   and {@link useAdvisors} hook to access the advisor mapping.
 *
 * It does this by querying for the advisor dataset on load.
 *
 * @param props - No custom properties, just children.
 */

export var AdvisorProvider = function AdvisorProvider(props) {
  var logger = useLogger();
  var advisorsPromise = useMemo( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var resp;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof fetch === 'undefined')) {
              _context.next = 3;
              break;
            }

            logger.debug('no fetch api found - skipping advisor data');
            return _context.abrupt("return", {});

          case 3:
            logger.debug('fetching advisor data');
            _context.prev = 4;
            _context.next = 7;
            return fetch("".concat(ADVISOR_HOST, "/index.json"), {
              mode: 'cors',
              method: 'GET',
              cache: 'default',
              credentials: 'omit',
              redirect: 'follow'
            });

          case 7:
            resp = _context.sent;

            if (!resp.ok) {
              _context.next = 14;
              break;
            }

            _context.next = 11;
            return resp.json();

          case 11:
            return _context.abrupt("return", _context.sent);

          case 14:
            throw new Error("Error fetching advisor data with status code ".concat(resp.status, ": ").concat(resp.statusText));

          case 15:
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](4);
            // log and re-throw
            logger.error(_context.t0);
            throw _context.t0;

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 17]]);
  })), [logger]);
  var result = usePromise(advisorsPromise);
  return /*#__PURE__*/React.createElement(AdvisorContext.Provider, _extends({
    value: result.status === 'fulfilled' ? result.value : {}
  }, props));
};